import { featureEnabled, correctShowingTypeLabel } from 'utils';
import { Modal } from 'components';

angular.module('bb.external').component('bbCoopAppointmentList', {
  bindings: {},
  controller: CoopAppointmentListCtrl,
  controllerAs: 'vm',
  template: require('./appointment_list_coop.html'),
});

CoopAppointmentListCtrl.$inject = [
  '$routeParams',
  'ExternalService',
  '$location',
  'ErrorService',
  'UtilService',
  'ExternalAuth',
  '$q',
  'appointmentListsService',
];

function CoopAppointmentListCtrl(
  $routeParams,
  ExternalService,
  $location,
  ErrorService,
  UtilService,
  ExternalAuth,
  $q,
  appointmentListsService,
) {
  const vm = this;

  vm.isCovidFlagEnabled = ExternalAuth.auth.hasFeature('COVID_19');

  vm.$onInit = function () {
    vm.dashboardId = $routeParams.dashboardId;
    vm.appointmentsLoaded = false;

    $q.all([
      ExternalService.getCoopAppointments(vm.dashboardId),
      UtilService.getServerDate(),
    ])
      .then(function ([{ appointments, listing }, { date }]) {
        vm.serverDate = date;
        vm.listing = listing;
        vm.appointments = appointments;
        vm.appointmentsLoaded = true;
        vm.status = $routeParams.status;
        vm.appointments.forEach(function (apt) {
          if ($routeParams.appointmentId === apt.id)
            vm.selectedAppointment = apt;
        });

        return appointmentListsService.getExternalListingConfig(
          vm.dashboardId,
          listing.id,
        );
      })
      .then(externalConfig => {
        vm.externalAppointmentConfig = externalConfig;
      })
      .catch(function (err) {
        vm.appointmentsLoaded = true;
        ErrorService.toastyHTTPErr(err);
      });

    vm.clearSelected = function () {
      $location.search({});
      $location.path(`/dash/${vm.dashboardId}/appointments`);
      vm.selectedAppointment = null;
    };

    vm.showDetailsRevamp = true;
    vm.correctShowingTypeLabel = correctShowingTypeLabel;
    if ($routeParams.appointmentId) {
      $location.path(
        `/dash/${vm.dashboardId}/showing/${$routeParams.appointmentId}`,
      );
    }
  };

  vm.handleBookShowingNavigation = () => {
    if (
      ExternalAuth.auth.hasFeature('PRE_BOOKING') &&
      vm.externalAppointmentConfig?.preBookingInformation
    ) {
      Modal.confirm({
        icon: null,
        title: 'Important Information',
        content: `${vm.externalAppointmentConfig.preBookingInformation}`,
        okText: 'Continue to booking',
        cancelText: 'Cancel',
        closable: true,
        onOk() {
          window.location.href = `/external/#/dash/${vm.dashboardId}/book`;
        },
      });
      return;
    }

    window.location.href = `/external/#/dash/${vm.dashboardId}/book`;
  };

  vm.preBookingNotificationFeature = featureEnabled(
    'preBookingNotificationFeature',
  );

  vm.updateAppointment = appointmentId => {
    ExternalService.getAppointment(vm.dashboardId, appointmentId).then(
      appointment => {
        const clonedAppointmentArray = [...vm.appointments];
        const index = clonedAppointmentArray.findIndex(
          appt => appt.id === appointment.id,
        );
        clonedAppointmentArray[index] = appointment.toJSON();
        vm.appointments = clonedAppointmentArray;
        vm.selectedAppointment = clonedAppointmentArray[index];
      },
    );
  };
}

export {};
